import { useState } from "react";

// Components
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";

// Assets
import { ReactComponent as XIcon } from "assets/cross.svg";

const ModalFormHubungkanAkun = ({
  onSubmit,
  onClose,
  onBack,
  isOpen,
  akun,
  ...props
}) => {
  const [email, setEmail] = useState("");

  return (
    <Modal isOpen={isOpen} onClose={onClose} {...props}>
      <div
        className="w-[426px] z-[42] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]"
      >
        <div className="flex justify-between px-4 py-2 border-b border-solid border-[#D8D8D9]">
          <p className="text-[17px] font-inter-semibold">Hubungkan Akun</p>
          <XIcon onClick={onClose} />
        </div>

        <div className="py-2 px-4 border-b border-dashed border-[#D8D8D9]">
          <img
            className="h-[32px] object-contain mb-2"
            src={akun.icon}
            alt={akun.name}
          />
          <p className="text-[13px] font-inter text-[#252526]">
            Email ini akan dipakai untuk menyambungkan akun ONE21 dengan{" "}
            {akun.name}
          </p>
        </div>
        <div className="py-4 px-4 flex items-center gap-4">
          <p className="text-[13px] font-inter text-[#252526] w-[126px]">
            Email<span>*</span>
          </p>
          <input
            value={email}
            onChange={(e) =>
              setEmail(e?.target?.value?.replace(" ", "")?.toLowerCase())
            }
            type="email"
            placeholder="nama@email.com"
            className="p-2 h-[32px] rounded-[4px] border border-solid border-[#D8D8D9] text-[13px] font-inter text-[#252526] placeholder:text-[#D8D8D9] w-full"
          />
        </div>

        <div className="flex gap-[12px] justify-end px-4 py-2 border-t border-solid border-[#D8D8D9]">
          <Button size="s" type="secondary" text="Kembali" onClick={onBack} />
          <Button disabled={!email} size="s" text="Hubungkan Akun" onClick={() => onSubmit(email)} />
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalFormHubungkanAkun isOpen={isOpen} {...props} />;
};

export default Wrapper;
